import { useTranslation } from '../hooks/useTranslation';

const LoginPage = ({
  username,
  password,
  loading,
  error,
  handleLogin,
  setUsername,
  setPassword
}) => {
  const { t } = useTranslation();

  return (
    <div className="d-flex align-items-center justify-content-center min-vh-100 position-relative" style={{
      background: 'radial-gradient(ellipse at top, #0d2847 0%, #050818 60%, #000 100%)',
      overflow: 'hidden'
    }}>
      <div style={{
        position: 'absolute', inset: 0, opacity: 0.08,
        backgroundImage: 'url("data:image/svg+xml,%3Csvg xmlns=%27%27http://www.w3.org/2000/svg%27%27 width=%27%27120%27%27 height=%27%27120%27%27 viewBox=%27%270 0 120 120%27%27%3E%3Ccircle cx=%27%2760%27%27 cy=%27%2760%27%27 r=%27%2730%27%27 fill=%27%27none%27%27 stroke=%27%27%23ffffff%27%27 stroke-width=%27%271.5%27%27/%3E%3Cpolygon points=%27%2760,40 70,48 66,60 54,60 50,48%27%27 fill=%27%27%23ffffff%27%27/%3E%3Cpolygon points=%27%2745,55 50,48 46,36 35,43%27%27 fill=%27%27%23ffffff%27%27/%3E%3Cpolygon points=%27%2775,55 85,43 74,36 70,48%27%27 fill=%27%27%23ffffff%27%27/%3E%3Cpolygon points=%27%2750,70 45,83 54,90 60,82 54,70%27%27 fill=%27%27%23ffffff%27%27/%3E%3Cpolygon points=%27%2770,70 66,82 72,92 83,85 75,72%27%27 fill=%27%27%23ffffff%27%27/%3E%3C/svg%3E")',
        backgroundRepeat: 'repeat',
        pointerEvents: 'none'
      }}></div>
      <div className="card border-0 p-5 w-100" style={{
        maxWidth: '420px',
        background: 'rgba(20, 25, 50, 0.6)',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        border: '1px solid rgba(100, 150, 255, 0.2)',
        boxShadow: '0 25px 60px rgba(0,0,0,0.6), 0 0 80px rgba(66, 165, 245, 0.15)',
        borderRadius: '16px',
        position: 'relative',
        zIndex: 1
      }}>
        <h1 className="text-center mb-4">{t('login.title')}</h1>
        <form onSubmit={handleLogin}>
          <div className="mb-3">
            <label htmlFor="username" className="form-label">{t('login.username')}</label>
            <div className="input-group">
              <span className="input-group-text"><i className="bi bi-person"></i></span>
              <input
                type="text"
                id="username"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                required
                className="form-control"
                placeholder={t('login.usernamePlaceholder')}
              />
            </div>
          </div>
          <div className="mb-3">
            <label htmlFor="password" className="form-label">{t('login.password')}</label>
            <div className="input-group">
              <span className="input-group-text"><i className="bi bi-lock"></i></span>
              <input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                className="form-control"
                placeholder={t('login.passwordPlaceholder')}
              />
            </div>
          </div>
          <button
            type="submit"
            disabled={loading}
            className={`btn btn-primary w-100 ${loading ? 'disabled' : ''}`}
          >
            {loading ? (
              <>
                <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                {t('login.submitting')}
              </>
            ) : (t('login.submit'))}
          </button>
        </form>
        {error && (<div className="alert alert-danger mt-3" role="alert">{t('common.error')}: {error}</div>)}
      </div>
      <div className="position-fixed bottom-0 start-0 end-0 text-center pb-3" style={{fontSize: '0.85rem', color: 'rgba(255,255,255,0.5)', zIndex: 2}}>
        設計 By 伊達數位
      </div>
    </div>
  );
};

export default LoginPage;
